<template>
  <div class="wizard-body small-9 columns container-center">
    <div class="terms-container container-center">
      <div class="logo__container">
        <div class="img__container">
          <img :src="src" :alt="title" />
        </div>
      </div>
      <h2 class="text title">
        {{ title }}
      </h2>
      <p class="text description description1__margin-top">
        {{ description[0] }}
      </p>
      <p class="text description description2__margin-top">
        {{ description[1] }}
        <a :href="description[2]" target="_blank">{{ description[2] }}</a>
        {{ description[3] }}
        <br />
        {{ description[4] }}
      </p>
      <label class="text checkbox_text">
        <input v-model="isAgreed" type="checkbox" />
        {{ description[5] }}
      </label>
      <div class="medium-12 columns section--button">
        <button
          class="button primary btn-continue"
          :disabled="!isAgreed"
          @click="nextStep()"
        >
          <span class="btn-text-center">{{
            $t('INBOX_MGMT.ADD.EVOLUTION_API.BUTTONS.CONTINUE_BUTTON')
          }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import router from '../../../../../index';
export default {
  data() {
    return {
      provider: 'evolution_api',
      src: '/assets/images/dashboard/channels/evolution_api.png',
      title: 'WhatsApp Business/Personal',
      description: this.$t('INBOX_MGMT.ADD.EVOLUTION_API.CONDITIONS_STEP'),
      isAgreed: false,
    };
  },
  methods: {
    nextStep() {
      const params = {
        page: 'new',
        sub_page: 'evolution_api',
      };
      router.push({ name: 'settings_inbox_add_name_and_number', params });
    },
  },
};
</script>

<style scoped lang="scss">
.wizard-body {
  justify-content: center;
}
.container-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.terms-container {
  width: 84rem;
  height: 50rem;
  overflow: hidden;
}
.logo__container {
  margin: var(--space-normal) auto;
  width: 9.6rem;
  height: 9.6rem;

  .img__container {
    padding: 20%;

    border-radius: 999px;
    background: #25d366;

    img {
      margin: unset;
      width: 100%;
    }
  }
}
.text {
  font-weight: var(--font-weight-normal);
  font-family: 'Source Sans Pro';
  color: var(--conversa2-neutral-800-color);
  text-align: center;

  &.title {
    font-size: 2.8rem;
    line-height: var(--space-large-plus);
    margin-top: var(--space-normal);
  }

  &.description {
    font-size: var(--font-size-small);
    line-height: var(--space-two);
  }

  &.checkbox_text {
    font-size: var(--font-size-small);
    line-height: var(--space-normal-plus);
    margin-top: var(--space-large-plus);
  }
}
.description1__margin-top {
  margin-top: var(--space-normal);
}
.description2__margin-top {
  margin-top: var(--space-large);
}
.btn-continue {
  width: 27rem;
  margin-top: var(--space-medium);
}
.btn-text-center {
  text-align: center;
  width: 100%;
}
</style>
